export default __webpack_public_path__ + "static/media/invoice.0f24e86e.svg";